module.exports = __webpack_public_path__ + "static/media/google-play.de5b44c6.svg";